<template>
  <section class="relative w-full h-screen/2 md:h-screen">
    <div class="fixed w-full h-screen/2 md:h-screen -z-10">
      <img class="w-full h-full object-cover" src="@/assets/workshop/1.jpg" />
      <div
        class="absolute inset-0 bg-opacity-50 flex flex-col items-center justify-center bg-black text-white py-2 px-4"
      >
        <AnimateText title="OUR WORKSHOP" />
        <p class="mt-4">Jl. Raya Gerudug, Mekar Jaya, Kec. Sepatan,</p>
        <p>Kabupaten Tangerang, Banten</p>
      </div>
    </div>
  </section>

  <section>
    <div class="bg-white p-4 md:p-8">
      <div class="mb-4 xl:p-24">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div class="flex items-center justify-center" v-for="(image, index) in workshop" :key="image">
            <img class="cursor-pointer object-cover w-96 h-96" @click="showViewer(index)" :src="image" />
          </div>
        </div>
        <VueEasyLightbox
          scrollDisabled
          escDisabled
          moveDisabled
          :visible="visible"
          :imgs="workshop"
          :index="index"
          @hide="handleHide"
        />
      </div>

      <div class="p-8">
        <Embed aspect="16/9" src="https://www.youtube.com/embed/_R1QEdVxeHw" />
      </div>
    </div>
  </section>
</template>

<script>
import { useHead } from '@vueuse/head';
import VueEasyLightbox from 'vue-easy-lightbox';
import AnimateText from '@/components/Animation/AnimateText.vue';
import Embed from '@/components/Embed.vue';

export default {
  components: {
    VueEasyLightbox,
    AnimateText,
    Embed,
  },
  setup() {
    useHead({
      title: `Workshop | ${process.env.VUE_APP_NAME}`,
    });
  },
  data() {
    return {
      workshop: [
        require('@/assets/workshop/2.jpg'),
        require('@/assets/workshop/3.jpg'),
        require('@/assets/workshop/4.jpg'),
        require('@/assets/workshop/5.jpg'),
      ],
      visible: false,
      index: 0,
    };
  },
  methods: {
    showViewer(index) {
      this.index = index ? index : 0;
      this.visible = true;
    },
    handleHide() {
      this.visible = false;
    },
  },
};
</script>
